import { VStack, Text, HStack } from '@chakra-ui/react';
import {
  getFormattedSubtotalPerCurrency,
  CartSubtotals
} from '@app/helpers/nft/nftCartHelpers';
import { FC } from 'react';

type Props = {
  groups: CartSubtotals;
};

export const CartTotalSection: FC<Props> = ({ groups }) => {
  const subtotals = getFormattedSubtotalPerCurrency(groups);

  return (
    <HStack width="100%" justifyContent="space-between" alignItems="flex-start">
      <Text fontWeight="400" fontSize="20px" lineHeight="22px" color="gray.15">
        Total Price
      </Text>
      <VStack alignItems="flex-end">
        {subtotals.map(currency => {
          return (
            <Text
              key={currency.token.symbol}
              fontWeight="600"
              fontSize="20px"
              lineHeight="28px"
            >
              {`${currency.formattedSubtotal} ${currency.token.name}`}
            </Text>
          );
        })}
      </VStack>
    </HStack>
  );
};
